// extracted by mini-css-extract-plugin
module.exports = {"qrBox":"qrBox___27HJb","waiting":"waiting___3p8wS","links":"links___WjbDy","manualBox":"manualBox___ozSp2"};